import * as React from 'react';
import useStep from './useStep';
import useTrackBookingStep from './useTrackBookingStep';
import useTrackBookingEvent from './useTrackBookingEvent';

export default function useBookingStepTracking(): void {
    const { step, stepAllowed } = useStep();
    const trackBookingStep = useTrackBookingStep();
    const trackBookingEvent = useTrackBookingEvent();

    React.useEffect(() => {
        if (stepAllowed) {
            const track = () => trackBookingStep(step);
            requestAnimationFrame(() => {
                requestAnimationFrame(track);
            });

            if (step === 'city') {
                const trackEvent = () => trackBookingEvent('custom_BF_city');

                requestAnimationFrame(() => {
                    requestAnimationFrame(trackEvent);
                });
            }
        }
    }, [step, stepAllowed, trackBookingStep, trackBookingEvent]);
}
